import React, { memo, useCallback } from 'react';
import { useReactFlow } from 'reactflow';
import useFlowsStore from '../../store/storeFlows';

interface EdgeDeleteButtonProps {
  id: string;
  labelX: number;
  labelY: number;
}

function EdgeDeleteButton({ id, labelX, labelY }: EdgeDeleteButtonProps) {
  const onEdgeDelete = useFlowsStore(state => state.onEdgeDelete);
  const { getEdge } = useReactFlow();

  const handleDelete = useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation();
      const edge = getEdge(id);
      if (edge) {
        onEdgeDelete([edge], id);
      }
    },
    [id, getEdge, onEdgeDelete],
  );

  return (
    <button
      type='button'
      onClick={handleDelete}
      style={{
        position: 'absolute',
        transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
        pointerEvents: 'all',
        width: 22,
        height: 22,
        borderRadius: '50%',
        backgroundColor: '#1976d2',
        color: 'white',
        border: '2px solid white',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '14px',
        fontWeight: 'bold',
        lineHeight: 1,
        padding: 0,
        boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
        zIndex: 1000,
      }}
    >
      ✕
    </button>
  );
}

export default memo(EdgeDeleteButton);
